import {Card, Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {AppointmentAddress} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentAddress';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import React from 'react';
import {ExamConfirmBookingButton} from '../ExamReviewBooking/components/ExamConfirmBookingButton';
import {useExamReviewBookingNew} from './hooks/useExamReviewBookingNew';
import {StyledContainer} from './styles';
import {ExamReviewBookingNewProps} from './types';

export function ExamReviewBookingNew({handlePrevStep}: ExamReviewBookingNewProps) {
	const {
		beneficiaryName,
		planName,
		providerName,
		specialtyName,
		clinicName,
		date,
		hour,
		formattedAddress,
		addressForMaps,
		handleOpenGoogleMaps,
		isAdvanceDiagnosticsExam,
	} = useExamReviewBookingNew();

	return (
		<StyledContainer>
			<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
				<Stack gap={3}>
					<AppointmentInfoList
						beneficiaryName={beneficiaryName}
						planName={planName}
						providerName={providerName}
						specialtyName={specialtyName}
						clinicName={clinicName}
						date={date}
						hour={hour}
						flowType={FlowEnum.EXAM}
						isAdvanceDiagnosticsExam={isAdvanceDiagnosticsExam}
					/>
					<AppointmentAddress
						formattedAddress={formattedAddress}
						addressForMaps={addressForMaps}
						handleOpenMap={handleOpenGoogleMaps}
					/>
				</Stack>
			</Card>
			<ExamConfirmBookingButton handleBack={handlePrevStep} />
		</StyledContainer>
	);
}
